import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getQueuesByResource } from '../../api/production-request-api/index.js';
import { useAppContext } from '../../providers';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook that gets the resource queues for the selected resource.
 * @param {boolean} active - Whether the query should be active.
 */
export const useResourceQueuesByStatus = (active) => {
  const { apiReady } = useApiReady();
  const { selectedResource } = useAppContext();

  return useQuery({
    queryKey: [QUERY_KEYS.RESOURCE_QUEUES, selectedResource],
    queryFn: () => getQueuesByResource(selectedResource),
    enabled: Boolean(apiReady && selectedResource && active),
  });
};
